import getProducts from './products';

export default (resources, country, type) => {
    const products = getProducts(country.url, type);
    const resourcesName = resources.map(resource => resource.name);
    return products.filter(product => !resourcesName.includes(product.resource));
}